import { IntlShape } from 'react-intl'

import { EquipmentRowDraft, createDraftFromRow } from 'pages/costs/common/equipmentSelectHelpers'

const drafts = new Map<string, EquipmentRowDraft>()
const listeners = new Map<string, Set<() => void>>()

const notify = (rowKey: string) => {
	const subs = listeners.get(rowKey)
	subs?.forEach((listener) => listener())
}

export const ensureDraft = (rowKey: string, rowData: any, intl: IntlShape) => {
	if (!drafts.has(rowKey)) {
		drafts.set(rowKey, createDraftFromRow(rowData, intl))
		notify(rowKey)
	}
}

export const getDraftSnapshot = (rowKey: string): EquipmentRowDraft | undefined => drafts.get(rowKey)

export const setDraftFromRow = (rowKey: string, rowData: any, intl: IntlShape) => {
	if (!rowData) {
		clearDraft(rowKey)
		return
	}
	drafts.set(rowKey, createDraftFromRow(rowData, intl))
	notify(rowKey)
}

export const updateDraft = (rowKey: string, patch: Partial<EquipmentRowDraft>) => {
	const current = drafts.get(rowKey) ?? {}
	const next: EquipmentRowDraft = { ...current, ...patch }
	drafts.set(rowKey, next)
	notify(rowKey)
}

export const clearDraft = (rowKey: string) => {
	if (drafts.delete(rowKey)) {
		notify(rowKey)
	}
}

export const subscribeToDraft = (rowKey: string, listener: () => void) => {
	let bucket = listeners.get(rowKey)
	if (!bucket) {
		bucket = new Set()
		listeners.set(rowKey, bucket)
	}

	bucket.add(listener)

	return () => {
		bucket?.delete(listener)
		if (bucket && bucket.size === 0) {
			listeners.delete(rowKey)
		}
	}
}
